"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _recommendationActions = require("../../store/recommendation/recommendationActions");
var _recommendationSelectors = require("../../store/recommendation/recommendationSelectors");
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
const useRecommendationBusinessAddon = () => {
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const isAddonSelected = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectIsAddonSelected);
  const handleAddonChange = isAddonSelected => {
    dispatch((0, _recommendationActions.setIsAddonSelected)(isAddonSelected));
  };
  return {
    isAddonSelected,
    handleAddonChange
  };
};
var _default = useRecommendationBusinessAddon;
exports.default = _default;